module.exports = __webpack_public_path__ + "static/media/1.7bac4000.png";